module.exports = __webpack_public_path__ + "img/Cholesterol CHOD POD.2(mid).6c47ceb2.jpg";